import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';
import UI from 'UI';
import _ from 'lodash';
import color from 'color';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const Container = styled.ul`
    margin: 0;
    padding: 0;
`;

const LIList = styled.li`
    display: flex;
    font-size: 18px;
    line-height: 40px;
    font-weight: 300;
    list-style: none;
    margin-bottom: 4px;
    position: relative;
    color: ${props => props.theme.primaryColor};

    &.pls_highlight {
        color: ${props => props.theme.content.accentColor};
    }

    &:last-child {
        margin-bottom: 0;
    }
    &.tl-header {
        line-height: 26px;
        color: ${props => props.theme.primaryTextColor};
        &:after {
            background-color: ${props =>
                color(props.theme.primaryColor)
                    .darken(0.3)
                    .toString()};
        }
        .name-header {
            flex-grow: 1;
        }
        .val-header {
            opacity: 0.9;
            font-weight: 300;
        }
    }
    &:before {
    }
    &:after {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -20px;
        right: 0px;
        content: ' ';
        z-index: 0;
        transform: skew(-20deg);
        background-color: currentColor;
    }

    & > * {
        z-index: 2;
    }

    .list-player-name {
        text-transform: uppercase;
        flex-grow: 1;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        z-index: 3;
        color: ${props => props.theme.primaryTextColor};
    }
    .tl-score,
    .val-header {
        position: relative;
        text-align: right;
        color: ${props => props.theme.primaryTextColor};
        margin-left: 0px;
        white-space: nowrap;
        position: relative;
        z-index: 3;
        display: block;
        text-align: right;
        margin-right: 20px;
        font-weight: normal;

        span {
            position: relative;
            z-index: 3;
        }
    }
    .tl-unit {
        font-size: 22px;
    }
`;

const Header = ({ valueTitle }, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');

    return (
        <LIList className="tl-header">
            <div className="name-header">{i18('name', lang)}</div>
            <div className="val-header">{valueTitle}</div>
        </LIList>
    );
};

const Row = ({ player, seasonId, highlightFirstPlayer, highlightTeam }) => {
    var name = RCore.getFirstLastName(player.name);
    return (
        <LIList
            key={player.id}
            className={highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''}
        >
            <div className="list-player-name">
                {name.firstName} <b>{name.lastName}</b>
            </div>
            <div className="tl-score">
                <span>{player.displayValue || player.value}</span>
            </div>
        </LIList>
    );
};

Header.contextTypes = {
    info: PropTypes.object
};

Row.contextTypes = {
    info: PropTypes.object
};

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/lists/WHPlayersList.js
 **/